import {
  P2GGrid,
  P2GText,
  P2GBox,
  P2GChip,
  P2GSwitch,
  P2GLink,
  P2GLinkGroup,
  P2GIcon,
  SvgClose
} from '@parcel2go/core-ui';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LazyCmsContent from '~/components/content/cms-content';
import { SidePanelContent } from '~/components/sidepanel-section';
import { SmartSendSettingsModel } from '~/lib/api/me/types';
import { TranslationNamespaces } from '~/lib/constants';

export const SmartSendSettings = ({
  value,
  onSave,
  saving,
  hideDetails,
  name,
  onUserDismiss
}: {
  name: string;
  saving: boolean;
  value: SmartSendSettingsModel;
  hideDetails?: boolean;
  onSave: (value: SmartSendSettingsModel) => void;
  onUserDismiss?: () => void;
}) => {
  const [hide, setHide] = useState(hideDetails || false);
  const { t } = useTranslation(TranslationNamespaces.SETTINGS);
  return (
    <P2GGrid container wrap="nowrap" alignItems="baseline" spacing={1}>
      <P2GGrid item flexGrow={1}>
        <SidePanelContent>
          <P2GText variant="subtitle2">
            {t(`SETTING_${name.toUpperCase()}_TITLE`, {
              defaultValue: 'Automatically Notify eCommerce Channels'
            })}
          </P2GText>
          <Suspense>
            <LazyCmsContent
              contentKey={`content-user-settings-${name.toLowerCase()}-description`}
              wrapper={(x) => <>{x}</>}
            >
              {hide ? (
                <P2GLinkGroup
                  links={[
                    <P2GLink onClick={() => setHide(false)}>
                      {t(`SETTING_MORE_INFO_BUTTON`, {
                        defaultValue: 'More Info'
                      })}
                    </P2GLink>
                  ]}
                />
              ) : (
                <>
                  <P2GBox display="flex" gap={1}>
                    <P2GChip size="small" label={t('SMARTSEND_TAG', { defaultValue: 'Smart Send' })} />
                  </P2GBox>
                  <P2GText>
                    {t(`SETTING_${name.toUpperCase()}_DESCRIPTION`, {
                      defaultValue:
                        'Automatically notify eCommerce channels of booking and tracking details letting buyers know when your item is with the courier.'
                    })}
                  </P2GText>
                </>
              )}
            </LazyCmsContent>
          </Suspense>
        </SidePanelContent>
      </P2GGrid>
      <P2GGrid item flexShrink={1}>
        <P2GSwitch
          disabled={saving}
          checked={value.AutoMarkAsDispatched}
          label={null}
          onChange={(v) => onSave({ ...value, AutoMarkAsDispatched: v })}
        />
      </P2GGrid>
      {onUserDismiss && (
        <P2GGrid item flexShrink={1}>
          <P2GIcon onClick={onUserDismiss}>
            <SvgClose />
          </P2GIcon>
        </P2GGrid>
      )}
    </P2GGrid>
  );
};
